<div class="modal-backdrop fixed inset-0 z-150 flex items-center justify-center p-4">
  <div class="modal-content w-full max-w-sm rounded-2xl overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-white/10">
      <h2 class="text-xl font-semibold text-text-primary">Zeit wählen</h2>
      <button type="button" class="p-2 rounded-xl text-text-muted hover:text-text-primary hover:bg-white/10 transition-all" (click)="close()">
        <span class="material-icons text-xl">close</span>
      </button>
    </div>

    <!-- Picker -->
    <div class="p-6">
      <div class="grid grid-cols-2 gap-4">
        <!-- Hours -->
        <div class="picker-column">
          <span class="picker-column-label">Stunden</span>
          <div class="picker-options">
            @for (hour of hours; track hour) {
              <button
                type="button"
                class="picker-option"
                [class.selected]="selectedHour() === hour"
                (click)="selectHour(hour)"
              >
                {{ hour }}
              </button>
            }
          </div>
        </div>

        <!-- Minutes -->
        <div class="picker-column">
          <span class="picker-column-label">Minuten</span>
          <div class="picker-options">
            @for (minute of minutes; track minute) {
              <button
                type="button"
                class="picker-option"
                [class.selected]="selectedMinute() === minute"
                [disabled]="isMinuteDisabled(minute)"
                (click)="selectMinute(minute)"
              >
                {{ minute.toString().padStart(2, '0') }}
              </button>
            }
          </div>
        </div>
      </div>

      <!-- Preview -->
      <div class="picker-preview">
        {{ preview() }}
      </div>
    </div>

    <!-- Actions -->
    <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-white/10">
      <button type="button" class="btn-secondary px-5 py-2.5 text-sm" (click)="close()">Abbrechen</button>
      <button type="button" class="btn-primary px-5 py-2.5 text-sm" (click)="confirm()">Übernehmen</button>
    </div>
  </div>
</div>
